var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip',{attrs:{"text":_vm.styleName,"position":"left"}},[_c('img',{staticClass:"style-icon cursor-pointer",attrs:{"id":"change-map-style-img","src":_vm.styleImg},on:{"click":function($event){$event.stopPropagation();return _vm.onChangeMapStyle()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }